import { Link } from "react-router-dom";
import TopBar from "@/components/feature/TopBar";
import SubpageHeader from "@/components/feature/SubpageHeader";
import Footer from "@/components/feature/Footer";
import FloatingWhatsApp from "@/components/feature/FloatingWhatsApp";
import MobileCta from "@/components/feature/MobileCta";

export default function Terms() {
  return (
    <div className="min-h-screen bg-background-50">
      <div className="fixed inset-x-0 top-0 z-50">
        <TopBar />
        <SubpageHeader />
      </div>

      <main className="pt-[140px] pb-16 md:pt-[160px] md:pb-24">
        <article className="mx-auto max-w-3xl px-4 md:px-6">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-accent-400 hover:text-accent-300"
          >
            <i className="ri-arrow-left-line" />
            Voltar ao início
          </Link>

          <h1 className="mt-4 font-heading text-3xl font-medium leading-tight text-foreground-50 md:text-4xl">
            Termos de Uso
          </h1>
          <p className="mt-3 text-sm text-foreground-500">Última atualização: agosto de 2026</p>

          <div className="mt-8 space-y-8 text-base leading-relaxed text-foreground-400">
            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                1. Finalidade do site
              </h2>
              <p className="mt-3">
                Este site tem caráter institucional e educativo, apresentando informações sobre a
                atuação da Dra. Sâmia Albuquerque em medicina estética. O conteúdo não substitui
                consulta, diagnóstico ou avaliação médica individual.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                2. Natureza das informações
              </h2>
              <p className="mt-3">
                As informações apresentadas têm finalidade informativa. Indicações,
                contraindicações, benefícios, riscos, recuperação e resultados de qualquer
                procedimento variam conforme cada paciente e dependem de avaliação médica
                individual.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                3. Agendamento
              </h2>
              <p className="mt-3">
                O agendamento de avaliações ocorre mediante contato prévio pelo WhatsApp ou pelo
                formulário do site. O preenchimento do formulário não configura agendamento
                confirmado até o retorno da nossa equipe.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                4. Propriedade intelectual
              </h2>
              <p className="mt-3">
                Os textos, imagens e demais elementos deste site são protegidos por direitos
                autorais. A reprodução, no todo ou em parte, depende de autorização prévia.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">
                5. Limitações
              </h2>
              <p className="mt-3">
                Este site é disponibilizado "como está", sem garantias de disponibilidade
                ininterrupta. Não nos responsabilizamos pelo uso indevido das informações aqui
                contidas.
              </p>
            </section>

            <section>
              <h2 className="font-heading text-2xl font-semibold text-foreground-50">6. Contato</h2>
              <p className="mt-3">
                Para dúvidas sobre estes termos, fale conosco pelo WhatsApp (85) 98102-2809 ou pelo
                Instagram @drasamiaalbuquerque.
              </p>
            </section>
          </div>
        </article>
      </main>

      <Footer />
      <FloatingWhatsApp />
      <MobileCta />
    </div>
  );
}